module.exports = ".reply {\r\n    font-weight:bold;\r\n  }\r\n.red {\r\n    color:red;\r\n}\r\n.width150px{\r\n    width: 150px;\r\n    text-align: center;\r\n}\r\n.hide{\r\n    width:0px!important;\r\n    min-width:0px!important;\r\n    max-width:0px!important;\r\n    padding:0px;margin:0px;border-color:transparent;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/a0101-event/event.component.css
// module id = ./src/app/a0101-event/event.component.css
// module chunks = main